import Button from "common/components/Button/Button"
import { EN_CALENDAR, ES_CALENDAR } from "common/utils/date"
import { withFormik } from "formik"
import { addLocale } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setShowFechaOperacion } from "../redux/slices/newDocumentoSettingsSlice"
import { setFechaOperacion } from "../redux/slices/newDocumentoSlice"

const FechaPagoOperacion = ({
  values,
  handleSubmit,
  onHide,
  handleChange,
  isValid,
}: $TSMigrationFixMe) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  addLocale("es", ES_CALENDAR)
  addLocale("en", EN_CALENDAR)

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='fechaOperacion'>
            {t("crear.facturaRec.modal.operationDateLabel")}
          </label>
          <Calendar
            // @ts-expect-error TS(2769): No overload matches this call.
            autoFocus
            id='fechaOperacion'
            name='fechaOperacion'
            value={new Date(values.fechaOperacion)}
            locale={language}
            dateFormat='dd/mm/yy'
            mask='99/99/9999'
            onChange={handleChange}
            showIcon
            baseZIndex={2302}
          />
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>
          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object({
  fechaOperacion: Yup.string().min(3).required(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'fechaOperacion' does not exist on type '...
  mapPropsToValues: ({ fechaOperacion }) => ({
    fechaOperacion: new Date(fechaOperacion),
  }),
  handleSubmit: ({ fechaOperacion }, { props }) => {
    // @ts-expect-error TS(2339): Property 'setFechaOperacion' does not exist on typ...
    props.setFechaOperacion(new Date(fechaOperacion).getTime())
    // @ts-expect-error TS(2339): Property 'showFechaOperacion' does not exist on ty...
    props.showFechaOperacion(true)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(FechaPagoOperacion)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setFechaOperacion: (fecha: $TSMigrationFixMe) =>
    dispatch(setFechaOperacion(fecha)),
  showFechaOperacion: (show: $TSMigrationFixMe) =>
    dispatch(setShowFechaOperacion(show)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  fechaOperacion: newDocumentoSelector(state).fechaOperacion,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
